import TOP_BARS from '@/utils/topBars';

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'My HSYLC',
      topBar: TOP_BARS.DEFAULT
    },
    component: () => import('@/views/Dashboard')
  }
];
